import Button from '@components/Button';
import Image from '@components/Image';
import { ImageType } from '@types';
import { createEvent } from 'effector';
import { createGate, useStore } from 'effector-react';

export const groupCaptureWidget = {
  capture: createEvent<void>(),
  gate: createGate({ defaultState: false }),
};

export function GroupCaptureWidget() {
  const isOn = useStore(groupCaptureWidget.gate.state);
  if (!isOn) return null;

  return (
    <>
      <Image
        className="pointer-events-none absolute"
        src="/imgs/map-capture.14f69ffa28efacea7ec8a8b773ec5c69.png"
        type={ImageType.sysMedia}
      />
      <Button
        className="absolute mt-300"
        onClick={() => groupCaptureWidget.capture()}
      >
        把当前视角设为分组视角
      </Button>
    </>
  );
}
